module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.shovValidate ? 'mainContainer show' : 'mainContainer'
  }, [_c('div', {
    class: _vm.valid ? 'dropdownWrapper complete' : 'dropdownWrapper incomplete'
  }, [_c('div', {
    class: _vm.opened ? "v_dropdown-write opened" : "v_dropdown-write"
  }, [_c('span', {
    staticClass: "focus-bg"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "focus": _vm.open,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wtf",
    on: {
      "click": _vm.wtf
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.opened ? "options active" : "options"
  }, [_c('div', {
    staticClass: "overflow"
  }, [(_vm.filtered.length) ? _vm._l((_vm.filtered), function(opt) {
    return _c('div', {
      class: _vm.active === opt.text ? "opt active" : "opt",
      on: {
        "click": function($event) {
          return _vm.select(opt.text, opt.value)
        }
      }
    }, [_vm._v("\n\n\t\t\t\t\t" + _vm._s(opt.text) + "\n\t\t\t\t")])
  }) : [_c('div', {
    staticClass: "null"
  })]], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73063049"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/elements/dropdown-write.vue
// module id = 276
// module chunks = 37